import { createRouter, createWebHistory } from "vue-router";
import MainView from "../views/mainView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: MainView,
  },
  {
    path: "/main",
    name: "main",
    props: true,
    component: () =>
      import("../views/mainView.vue"),
  },
  {
    path: "/show",
    name: "show",
    props: true,
    component: () =>
      import("../views/showView.vue"),
  },
  {
    path: "/ground",
    name: "ground",
    component: () =>
      import("../views/groundView.vue"),
  },
  {
    path: "/groundshow",
    name: "groundshow",
    component: () =>
      import("../views/groundshowView.vue"),
  },
  {
    path: "/detection",
    name: "detection",
    component: () =>
      import("../views/detectionView.vue"),
  },
  {
    path: "/compare",
    name: "compare",
    component: () =>
      import("../views/compareView.vue"),
  },
  {
    path: "/business",
    name: "business",
    component: () =>
      import("../views/businessView.vue"),
  },
  {
    path: "/chat",
    name: "chat",
    component: () =>
      import("../views/chatView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
